_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[58],{

/***/ "1OyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "8eW+":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/return-n-warranty",
      function () {
        return __webpack_require__("Y2eq");
      }
    ]);
  

/***/ }),

/***/ "9dV9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__("q1tI");
var node_modules_react_default = /*#__PURE__*/__webpack_require__.n(node_modules_react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/shared/Collapsible/arrow_solid_black.svg
var arrow_solid_black = __webpack_require__("uOq5");
var arrow_solid_black_default = /*#__PURE__*/__webpack_require__.n(arrow_solid_black);

// CONCATENATED MODULE: ./components/shared/Collapsible/ArrowIcon.js


var ArrowIcon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ArrowIcon",
  componentId: "ylodw5-0"
})(["height:", "px;width:", "px;background-image:url(", ");background-repeat:no-repeat;background-size:contain;transform:rotate(", ");transition:background 0.3s ease;background-position:50% 50%;"], function (props) {
  return props.theme.baseline * 3;
}, function (props) {
  return props.theme.baseline * 3;
}, arrow_solid_black_default.a.url, function (props) {
  return props.isOpen ? '90deg' : '-90deg';
});
/* harmony default export */ var Collapsible_ArrowIcon = (ArrowIcon);
// CONCATENATED MODULE: ./components/shared/Collapsible/Text.js

var Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Text",
  componentId: "sc-1xnp960-0"
})(["width:100%;display:", ";transition:all 0.3 ease;margin-bottom:0;margin-top:", "px;p{margin-top:", "px;}@media ", "{flex:2;", "}"], function (props) {
  return props.isOpen ? 'block' : 'none';
}, function (props) {
  return props.theme.baseline * 4;
}, function (props) {
  return props.theme.baseline;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.disableIndent ? '' : 'margin-top: 0;';
});
/* harmony default export */ var Collapsible_Text = (Text);
// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var atoms_Text = __webpack_require__("wCgk");

// CONCATENATED MODULE: ./components/shared/Collapsible/Heading.js


var CollapseHead = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Heading__CollapseHead",
  componentId: "echz7j-0"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;@media ", "{align-items:flex-start;flex-flow:row-reverse;max-width:", "px;flex:1;}@media ", "{min-width:", "px;}"], function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.baseline * 41;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 63;
});
var HeadingWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Heading__HeadingWrapper",
  componentId: "echz7j-1"
})(["display:flex;align-items:flex-start;width:100%;@media ", "{margin-top:", "px;margin-left:", "px;}"], function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.halfBaseline;
}, function (props) {
  return props.theme.baseline * 2;
});
var Heading = Object(styled_components_browser_esm["default"])(atoms_Text["a" /* BodyTextHighlight */]).withConfig({
  displayName: "Heading",
  componentId: "echz7j-2"
})(["font-weight:bold;text-transform:uppercase;margin-bottom:0;max-width:80%;margin-right:auto;text-align:left;"]);
var HeadingNumber = Object(styled_components_browser_esm["default"])(atoms_Text["a" /* BodyTextHighlight */]).withConfig({
  displayName: "Heading__HeadingNumber",
  componentId: "echz7j-3"
})(["font-weight:bold;text-transform:uppercase;margin-bottom:0;margin-right:", "px;text-align:left;"], function (props) {
  return props.theme.halfBaseline;
});

// CONCATENATED MODULE: ./components/shared/Collapsible/index.js







var __jsx = node_modules_react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }








var Collapsible_Collapsible = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(Collapsible, _React$Component);

  var _super = _createSuper(Collapsible);

  function Collapsible() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Collapsible);

    _this = _super.call(this);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openCollapsible", function () {
      var isOpen = _this.state.isOpen;

      _this.setState({
        isOpen: !isOpen
      });
    });

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(Collapsible, [{
    key: "render",
    value: function render() {
      var isOpen = this.state.isOpen;
      var _this$props = this.props,
          number = _this$props.number,
          heading = _this$props.heading,
          children = _this$props.children,
          isLast = _this$props.isLast,
          disableIndent = _this$props.disableIndent;
      return /*#__PURE__*/node_modules_react_default.a.createElement(StyledCollapse, {
        isOpen: isOpen,
        isLast: isLast,
        disableIndent: disableIndent,
        onClick: this.openCollapsible
      }, /*#__PURE__*/node_modules_react_default.a.createElement(CollapseHead, null, /*#__PURE__*/node_modules_react_default.a.createElement(HeadingWrapper, null, number && /*#__PURE__*/node_modules_react_default.a.createElement(HeadingNumber, {
        bold: true
      }, number, "."), /*#__PURE__*/node_modules_react_default.a.createElement(Heading, {
        bold: true
      }, /*#__PURE__*/node_modules_react_default.a.createElement(react["Trans"], {
        id: heading.id
      }))), /*#__PURE__*/node_modules_react_default.a.createElement(Collapsible_ArrowIcon, {
        isOpen: isOpen
      })), /*#__PURE__*/node_modules_react_default.a.createElement(Collapsible_Text, {
        isOpen: isOpen,
        disableIndent: disableIndent
      }, children));
    }
  }]);

  return Collapsible;
}(node_modules_react_default.a.Component);

Collapsible_Collapsible.defaultProps = {
  isLast: false,
  disableIndent: false,
  number: null
};
var StyledCollapse = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapsible__StyledCollapse",
  componentId: "sc-85c1ze-0"
})(["cursor:pointer;display:flex;align-items:center;flex-flow:column;width:100%;margin-left:auto;margin-right:auto;border-top:2px solid ", ";border-bottom:", " solid ", ";padding:", "px 0;transition:all 0.3 ease;@media ", "{flex-flow:", ";align-items:flex-start;}"], function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.isLast ? '2px' : '0';
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.baseline * 4;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.disableIndent ? 'column' : 'row';
});
/* harmony default export */ var shared_Collapsible = __webpack_exports__["a"] = (Collapsible_Collapsible);

/***/ }),

/***/ "JX7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "Ji7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inherits; });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("s4An");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(subClass, superClass);
}

/***/ }),

/***/ "Y2eq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./components/wrappers/Layout/index.js + 33 modules
var Layout = __webpack_require__("8hyx");

// EXTERNAL MODULE: ./components/shared/Meta/index.js + 6 modules
var Meta = __webpack_require__("ACIN");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/shared/Row/index.js
var Row = __webpack_require__("OfJt");

// EXTERNAL MODULE: ./components/shared/PageBlocks/index.js + 1 modules
var PageBlocks = __webpack_require__("gEiI");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// EXTERNAL MODULE: ./components/shared/Collapsible/index.js + 3 modules
var Collapsible = __webpack_require__("9dV9");

// EXTERNAL MODULE: ./components/atoms/TextTable/index.jsx
var TextTable = __webpack_require__("dEeW");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// CONCATENATED MODULE: ./components/shared/ContactEmail/index.jsx
var __jsx = react_default.a.createElement;

var ContactEmail_InfoEmail = function InfoEmail() {
  return /*#__PURE__*/react_default.a.createElement("a", {
    href: "mailto:info@soundboks.com"
  }, "info@soundboks.com");
};
// EXTERNAL MODULE: ./utils/hooks/useCheckRegion.js
var useCheckRegion = __webpack_require__("h5Ls");

// CONCATENATED MODULE: ./components/pages/Return/Sections/Return.js
var Return_jsx = react_default.a.createElement;










var Return_Return = function Return() {
  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isNA = _useCheckRegion.isNA;

  return /*#__PURE__*/react_default.a.createElement(Collapsible["a" /* default */], {
    heading:
    /*i18n*/
    {
      id: "page.return-n-warranty.returns-and-cancellations"
    }
  }, /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section1.body",
    components: [/*#__PURE__*/react_default.a.createElement("br", null)]
  })), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement(TextTable["a" /* default */], {
    columns: 4
  }, /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row1.col2.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row1.col2"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row1.col3.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row1.col3"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row1.col4.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row1.col4"
  })), /*#__PURE__*/react_default.a.createElement(TableHeader, null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row2.col1.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row2.col1"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row2.col2.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row2.col2"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row2.col3.na",
    components: [/*#__PURE__*/react_default.a.createElement("br", null)]
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row2.col3",
    components: [/*#__PURE__*/react_default.a.createElement("br", null)]
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row2.col4.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row2.col4"
  })), /*#__PURE__*/react_default.a.createElement(TableHeader, null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row3.col1.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row3.col1"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row3.col2.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row3.col2"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row3.col3.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row3.col3"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row3.col4.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row3.col4"
  })), /*#__PURE__*/react_default.a.createElement(TableHeader, null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row4.col1.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row4.col1"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row4.col2.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row4.col2"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row4.col3.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row4.col3"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row4.col4.na"
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section2.table.row4.col4"
  }))), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section3.body",
    components: [/*#__PURE__*/react_default.a.createElement(ContactEmail_InfoEmail, null), /*#__PURE__*/react_default.a.createElement("br", null)]
  })), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null), !isNA && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section4.headline"
  })), /*#__PURE__*/react_default.a.createElement("br", null)), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section4.body.na",
    components: [/*#__PURE__*/react_default.a.createElement(ContactEmail_InfoEmail, null), /*#__PURE__*/react_default.a.createElement("br", null)]
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section4.body",
    components: [/*#__PURE__*/react_default.a.createElement(ContactEmail_InfoEmail, null), /*#__PURE__*/react_default.a.createElement("br", null)]
  })), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null), !isNA && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section5.headline"
  })), /*#__PURE__*/react_default.a.createElement("br", null)), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, isNA ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section5.body.na",
    components: [/*#__PURE__*/react_default.a.createElement(ContactEmail_InfoEmail, null), /*#__PURE__*/react_default.a.createElement("br", null)]
  }) : /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section5.body",
    components: [/*#__PURE__*/react_default.a.createElement(ContactEmail_InfoEmail, null), /*#__PURE__*/react_default.a.createElement("br", null)]
  })), !isNA && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section6.headline"
  })), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "page.return-n-warranty.section6.body"
  }))));
};

var TableHeader = Object(styled_components_browser_esm["default"])(Text["k" /* P */]).withConfig({
  displayName: "Return__TableHeader",
  componentId: "sc-2t6i2y-0"
})(["font-weight:700 !important;color:", " !important;"], theme["a" /* default */].colors.primary);
/* harmony default export */ var Sections_Return = (Return_Return);
// CONCATENATED MODULE: ./components/pages/Return/Sections/Warranty.js
var Warranty_jsx = react_default.a.createElement;






var Warranty_WarrantyNO = function WarrantyNO() {
  return /*#__PURE__*/react_default.a.createElement(Collapsible["a" /* default */], {
    isLast: true,
    heading:
    /*i18n*/
    {
      id: "FIVE-YEAR LIMITED WARRANTY"
    }
  }, /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WARRANTY"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "The SOUNDBOKS is covered by a five-year limited consumer warranty, issued by SOUNDBOKS ApS. The warranty is issued to the customer who buys a new SOUNDBOKS directly from SOUNDBOKS ApS. This warranty cannot be assigned or transferred to any subsequent purchaser or user. Any SOUNDBOKS bought by official retailers have their own warranty issued by this external retailer.<0/><1/>SOUNDBOKS warrants to the customer that the device will under normal use function substantially in accordance with SOUNDBOKS' technical specifications or accompanying product documentation for a period of five years from the date of the original purchase.",
    components: [/*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
  }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "The limited 5 year warranty will be voided if the purchaser rents a SOUNDBOKS product to a third party user and damages are incurred during third party use."
  })), /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], null, "\xA0"), /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "REPAIR"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "The five-year limited consumer warranty starts from the day the Consumer receives the SOUNDBOKS. This warranty only covers repairs that need to be performed due to manufacturing errors and/or damage occurred during transport. SOUNDBOKS does not cover repairs needed due to hazardous use or excessive handling of the SOUNDBOKS by the customer."
  })));
};

var Warranty_WarrantyDefault = function WarrantyDefault() {
  return /*#__PURE__*/react_default.a.createElement(Collapsible["a" /* default */], {
    isLast: true,
    heading:
    /*i18n*/
    {
      id: "TWO-YEAR LIMITED WARRANTY"
    }
  }, /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WARRANTY"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "The SOUNDBOKS is covered by a two-year limited consumer warranty, issued by SOUNDBOKS ApS. The warranty is issued to the customer who buys a new SOUNDBOKS directly from SOUNDBOKS ApS. This warranty cannot be assigned or transferred to any subsequent purchaser or user. Any SOUNDBOKS bought by official retailers have their own warranty issued by this external retailer.<0/><1/>SOUNDBOKS warrants to the customer that the device will under normal use function substantially in accordance with SOUNDBOKS' technical specifications or accompanying product documentation for a period of two years from the date of the original purchase.",
    components: [/*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
  }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "The limited 2 year warranty will be voided if the purchaser rents a SOUNDBOKS product to a third party user and damages are incurred during third party use."
  })), /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], null, "\xA0"), /*#__PURE__*/react_default.a.createElement(Text["l" /* Span */], {
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "REPAIR"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "The two-year limited consumer warranty starts from the day the Consumer receives the SOUNDBOKS. This warranty only covers repairs that need to be performed due to manufacturing errors and/or damage occurred during transport. SOUNDBOKS does not cover repairs needed due to hazardous use or excessive handling of the SOUNDBOKS by the customer."
  })));
};

var Warranty_Warranty = function Warranty() {
  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isNO = _useCheckRegion.isNO;

  if (isNO) return /*#__PURE__*/react_default.a.createElement(Warranty_WarrantyNO, null);
  return /*#__PURE__*/react_default.a.createElement(Warranty_WarrantyDefault, null);
};

/* harmony default export */ var Sections_Warranty = (Warranty_Warranty);
// CONCATENATED MODULE: ./components/pages/Return/index.js
var pages_Return_jsx = react_default.a.createElement;








var Return_TermsPage = function TermsPage() {
  return /*#__PURE__*/react_default.a.createElement(StyledTermsPage, null, /*#__PURE__*/react_default.a.createElement(PageBlocks["a" /* PageTitle */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "RETURN & WARRANTY"
  })), /*#__PURE__*/react_default.a.createElement(CollapseList, null, /*#__PURE__*/react_default.a.createElement(Sections_Return, null), /*#__PURE__*/react_default.a.createElement(Sections_Warranty, null)));
};

var StyledTermsPage = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Return__StyledTermsPage",
  componentId: "sc-1pgy249-0"
})(["padding:", "px ", "px ", "px ", "px;@media ", "{padding:", "px 0;margin-left:auto;margin-right:auto;}@media ", "{padding:", "px 0;}@media ", "{padding:", "px 0;}"], function (props) {
  return props.theme.halfBaseline * 18;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.halfBaseline * 12;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.halfBaseline * 15;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.baseline * 9;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 12;
});
var CollapseList = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Return__CollapseList",
  componentId: "sc-1pgy249-1"
})(["position:relative;width:100%;height:100%;"]);
/* harmony default export */ var pages_Return = (Return_TermsPage);
// CONCATENATED MODULE: ./pages/return-n-warranty.js
var return_n_warranty_jsx = react_default.a.createElement;





var return_n_warranty_ReturnWarranty = function ReturnWarranty() {
  var pageInfo = {
    title:
    /*i18n*/
    {
      id: "returnNWarranty.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "returnNWarranty.meta.description"
    },
    url: '/return-n-warranty'
  };
  return /*#__PURE__*/react_default.a.createElement(Layout["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: pageInfo
  }), /*#__PURE__*/react_default.a.createElement(pages_Return, null));
};

/* harmony default export */ var return_n_warranty = __webpack_exports__["default"] = (return_n_warranty_ReturnWarranty);

/***/ }),

/***/ "cDf5":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "dEeW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("vOnD");
/* harmony import */ var styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NVT0");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var TextTable = function TextTable(_ref) {
  var columns = _ref.columns,
      children = _ref.children;
  var newLineAt = columns + 1;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Table, {
    newLineAt: newLineAt,
    columns: columns
  }, children);
};

var Table = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
  displayName: "TextTable__Table",
  componentId: "tw0ash-0"
})(["display:inline-grid;grid-template-columns:repeat(", ",auto);width:100%;overflow-x:auto;height:", ";> *{font-weight:700;padding:", ";color:", ";@media ", "{padding:", ";}@media ", "{padding:", ";}}> *:nth-child(n + ", "){font-weight:400;color:", ";border-top:solid 1px ", ";}"], function (props) {
  return props.columns;
}, function (props) {
  return props.newLineAt;
}, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].space.inset.s, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].colors.primary, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].breakpoints.tablet, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].space.inset.m, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].breakpoints.desktopLarge, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].space.inset.l, function (props) {
  return props.newLineAt;
}, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].colors.black, styles_theme__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].colors.grey);
/* harmony default export */ __webpack_exports__["a"] = (TextTable);

/***/ }),

/***/ "foSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "gEiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ PageBlocks_PageTitle; });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// CONCATENATED MODULE: ./components/shared/PageBlocks/PageTitle/index.js
var __jsx = react_default.a.createElement;




var PageTitle_PageTitle = function PageTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react_default.a.createElement(StyledPageTitle, null, /*#__PURE__*/react_default.a.createElement(Text["c" /* H1 */], null, children));
};

var StyledPageTitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PageTitle__StyledPageTitle",
  componentId: "m610zz-0"
})(["margin-bottom:", "px;h1{width:", "px;margin-bottom:", "px;}@media ", "{width:", "px;margin-bottom:", "px;h1{width:100%;margin-bottom:", "px;}}@media ", "{width:", "px;margin-bottom:", "px;}@media ", "{width:", "px;margin-bottom:", "px;}"], function (props) {
  return props.theme.baseline * 3;
}, function (props) {
  return props.theme.baseline * 20;
}, function (props) {
  return props.theme.halfBaseline * 9;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 75;
}, function (props) {
  return props.theme.baseline * 11;
}, function (props) {
  return props.theme.baseline * 3;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.baseline * 25;
}, function (props) {
  return props.theme.baseline * 9;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 94;
}, function (props) {
  return props.theme.baseline * 12;
});
/* harmony default export */ var PageBlocks_PageTitle = (PageTitle_PageTitle);
// CONCATENATED MODULE: ./components/shared/PageBlocks/index.js



/***/ }),

/***/ "md7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cDf5");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("JX7q");


function _possibleConstructorReturn(self, call) {
  if (call && (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(self);
}

/***/ }),

/***/ "s4An":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "uOq5":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMzAgMzAiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGNsaXAtcGF0aDogdXJsKCNjbGlwLWFycm93X3NvbGlkX3doaXRlKTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMjEyMjIyOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtYXJyb3dfc29saWRfd2hpdGUiPgogICAgICA8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgogIDxnIGlkPSJhcnJvd19zb2xpZF93aGl0ZSIgY2xhc3M9ImNscy0xIj4KICAgIDxwYXRoIGlkPSJQYXRoXzE1MzUiIGRhdGEtbmFtZT0iUGF0aCAxNTM1IiBjbGFzcz0iY2xzLTIiIGQ9Ik0zMCwxMS40SDEwLjA1bDcuNzI1LTcuNzI1TDE0LjAyNSwwLDMuNjc1LDEwLjM1LDAsMTQuMDI1SDBMMi45MjUsMTYuOTVsMTEuMSwxMS4xLDMuNzUtMy42NzVMMTAuMDUsMTYuNjVIMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNzUpIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzIxMjYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDIxMjYiIGNsYXNzPSJjbHMtMyIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIi8+CiAgPC9nPgo8L3N2Zz4K" };

/***/ }),

/***/ "vuIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _createClass; });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ })

},[["8eW+",0,1,2,3,4,5,6,7]]]);